<div [ngClass]="class" *ngIf="hasMore">
	<div class="col d-flex justify-content-center">
		<btn-loading
			[btnClass]="outline ? 'btn-load-more-outline' : 'btn-primary'"
			(click)="loadMoreCallback()"
			[loading]="loading"
			[loadingPosition]="loadingPosition"
		>
			<i class="fal fa-chevron-down mr-2" *ngIf="!loading && loadingPosition !== 'after'"></i>
			{{ 'loadMore' | translate }}
			<i class="fal fa-chevron-down ml-2" *ngIf="!loading && loadingPosition === 'after'"></i>
		</btn-loading>
	</div>
</div>
